import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeletion-loader.component.html',
  styleUrls: ['./skeletion-loader.component.scss'],
})
export class SkeletionLoaderComponent implements OnInit {
  @Input() isHorizontal = true;
  @Input() skeletonLoaderClass = '';
  @Input() loaderType:any;
  totalTime:any = [{},{},{},{},{},{},{},{},{}];
  @Input() cardType:any;
  @Input() filterLoader:any;
  @Input() showBannerLoader!:boolean;
  exploreSchemes:any = [{},{},{},{},{}];
  findSchemes:any = [{},{},{}];
  stateTotalTime:any = [{},{},{},{},{},{},{}];

  @Input() doNotShowSearch: boolean = false;

  constructor() {}

  ngOnInit() {
    this.loaderType;
  }
}
